function scroll(){
	$('html, body').animate({
        scrollTop: $( $(this).attr('href') ).offset().top - 50
    }, 300);

	$('.js-hubspot-form input:text').first().focus();
}

$('.js-anchor-scroll').on('click', scroll);
